//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionInput(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 9H4V20H20V9H16V7H22V22H2V7H8V9ZM12 14.5L9 11H11V2H13V11H15L12 14.5Z" fill="currentColor" /></svg>;
}
export default IconActionInput;